import { Routes, Route, Navigate } from "react-router-dom";
import { getStoredUser, isTokenExpired } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import RoutinesPage from "@/pages/RoutinesPage";
import RoutineEditPage from "@/pages/RoutineEditPage";
import ExercisesPage from "@/pages/ExercisesPage";
import SessionNewPage from "@/pages/SessionNewPage";
import SessionPage from "@/pages/SessionPage";
import ProgressPage from "@/pages/ProgressPage";
import Layout from "@/components/Layout";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = getStoredUser();
  if (!user || isTokenExpired()) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="routines" element={<RoutinesPage />} />
        <Route path="routines/new" element={<RoutineEditPage />} />
        <Route path="routines/:id" element={<RoutineEditPage />} />
        <Route path="exercises" element={<ExercisesPage />} />
        <Route path="session/new" element={<SessionNewPage />} />
        <Route path="session/:id" element={<SessionPage />} />
        <Route path="progress" element={<ProgressPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
